import { v4 as uuid } from 'uuid';
const sessionStorageKey = 'ECOS_TELEMETRY_INSTANCE_ID';

export const getInstanceId = (): string => {
  let instanceId = window.sessionStorage.getItem(sessionStorageKey);
  if (!instanceId) {
    instanceId = uuid();
    window.sessionStorage.setItem(sessionStorageKey, instanceId);
  }

  return instanceId;
};
